import React from "react";

const LoadingSpinner = ({spinner_div_id = "status"}) => {
    return (
        <div id=""> 
            <div id={spinner_div_id}>
                <div className="spinner-chase">
                    <div className="chase-dot" />
                    <div className="chase-dot" />
                    <div className="chase-dot" />
                    <div className="chase-dot" />
                    <div className="chase-dot" />
                    <div className="chase-dot" />
                </div>
            </div>
        </div>
    )
}

export default LoadingSpinner;